import { render } from "./double-control-time.vue?vue&type=template&id=0fcc5522&ts=true"
import script from "./double-control-time.vue?vue&type=script&lang=ts"
export * from "./double-control-time.vue?vue&type=script&lang=ts"

import "./double-control-time.vue?vue&type=style&index=0&id=0fcc5522&lang=less"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__